export default {
  club_name: 'Örebro HK',
  club_name_short: 'orebrohk',
  stadium_name: '',
  staging_url: 'https://orebrohk.api.fangroup.io',
  prod_url: 'https://orebrohk.api.fangroup.io',
  api: '/api',
  facebook: '',
  basename: '/orebrohk',
  club_logo: '/assets/teams/orebrohk.png',
  app_name: 'orebrohk',
  websale_name: 'orebrohk',
  ntb_team_id: 10057,
  microservice_url: 'https://stats.api.fangroup.io',
  currencyCaps: 'SEK',
  currencyShort: 'Kr',
  currencyShortSmall: 'kr',
  clubSportalityAvailable: false,
  leagueSportalityAvailable: false,
  cloudIdName: 'orebrohk',
  monolithEnabled: false,
};
